module.exports = __webpack_public_path__ + "static/media/3.Paint Zoom Electric.d64121d9.jpg";